/**
 * Identidad fiscal del prestador — FUENTE ÚNICA.
 *
 * ANDAR Labs es una marca comercial de Maurizio Pasian (trabalhador
 * independente, Portugal), NO una sociedad constituida. La marca domina las
 * superficies comerciales; la identidad fiscal aparece en las superficies
 * legales (footer, /privacy, /terms) vía este módulo, nunca hardcodeada.
 *
 * `nif` vacío = las líneas de NIF no se renderizan (nunca publicar un
 * placeholder). Completar con el NIF real antes del launch; al hacerlo,
 * bumpear `lg_updated` en los 5 locales. Cuando exista la Unipessoal Lda.,
 * este módulo (y las claves i18n `footer_brand_line`/`lg_p_s1_p1`/
 * `lg_t_s13_p1`) son los únicos puntos a actualizar.
 */
export const LEGAL_IDENTITY = {
  brand: "ANDAR Labs",
  owner: "Maurizio Pasian",
  /** NIF de persona física (Portugal). Verificado: dígito de control OK. */
  nif: "316659762",
} as const;

/**
 * Fragmento ", NIF 123456789" para intercalar en copy legal (token `%NIF%`
 * de LegalPage). Vacío si el NIF aún no está cargado.
 */
export function nifFragment(): string {
  return LEGAL_IDENTITY.nif ? `, NIF ${LEGAL_IDENTITY.nif}` : "";
}
